import { Observable } from 'rxjs';

import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AUTH_SERVICE_TOKEN, AuthFacade } from '@coin-depo-core/auth';
import { AppConfig, APP_CONFIG } from '@coin-depo-config/tokens';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(
    @Inject(AUTH_SERVICE_TOKEN) private authService: AuthFacade,
    @Inject(APP_CONFIG) private config: AppConfig,
    private router: Router
  ) {}

  public canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    const authorized = this.authService.isLoggedIn;

    if (!authorized) {
      return this.router
        .navigate([this.config.loginUrl])
        .then(() => authorized);
    }

    return authorized;
  }

  public canActivateChild(): Observable<boolean> | Promise<boolean> | boolean {
    const authorized = this.authService.isLoggedIn;

    if (!authorized) {
      return this.router
        .navigate([this.config.loginUrl])
        .then(() => authorized);
    }

    return authorized;
  }
}
